import React from 'react';
import { useNavigate } from "react-router-dom";

const InnerPage = ({ title, children }) => {
  const navigate = useNavigate();

  return (
    <div className="proskins-content" style={{
      padding: 'var(--spacing-lg)',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 'var(--spacing-sm)'
      }}>
        <h1 className="proskins-section-title" style={{margin: 0}}>{title}</h1>
        <button
          className="proskins-btn proskins-btn-outline"
          onClick={() => navigate('/')}
        >
          ← Back to Homepage
        </button>
      </div>
      {children}
    </div>
  );
};

export default InnerPage;